import router from "@/router/index";
import * as model from "@/model/prd/qualityMgt/selfTest/SelfTestPelletizingPel";
import {
  newEntityStoreHelper
} from "@/store/common/entityModule";

function newFilter(paginationFilter = {}) {
  var filter = Object.assign({}, paginationFilter, model.filter)
  return filter;
}

export default newEntityStoreHelper(() => new model.SelfTestPelletizingPel(), newFilter)
  .withStates({
    idReport: 2,
    baseModuleUrl: process.env.VUE_APP_PRODUCTION_API_URL + "production-service/prd",
    selfTestId: '',
  }) //TODO load at the application start
  .withActions({
    updateSelfTestId(context, id) {
      context.state.selfTestId = id;
    },
    Save(context) {
      context.dispatch("api/put", {
        url: context.state.baseModuleUrl + "/" + "selfTestPelletizingPel",
        entity: context.state.entity,
        module: 'selfTestPelletizingPel'
      }, {
        root: true
      }).then(function () {
        context.dispatch("base/showSuccess", {
          userAlertSuccessStr: "Sucess!",
          dismissCountDown: 5,
          userAlertSuccessVisible: false,
        }, {
          root: true
        }).then(function () {
          router.push({
            path: '/prd/selfTestPelletizingPel',
            query: {
              id:  context.state.selfTestId,
            }
          });
        })
      });

    },
    BackToList(context){
      router.push({
        path: '/prd/selfTestPelletizingPel',
        query: {
          id:  context.state.selfTestId,
        }
      });
    },
    Load(context, id) {
      context.dispatch("selfTestPelletizingPel/updateSelfTestId", id, {
        root: true
      });
      context.dispatch("api/get", {
          url: context.state.baseModuleUrl + "/selfTestPelletizingPel/findBySelfTestPelletizing/" + id
        }, {
          root: true
        })
        .then(response => {
          context.commit("selfTestPelletizingPel" + "/setRows", response, {
            root: true
          });

        });
    }

  })
  .buildStore()